export default "__VITE_ASSET__bc6d6338__"